// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uGfn","buttons":"styles_buttons__3-R5x"};